import usePublishedPollRemainingTime from '../../../usePublishedPollRemainingTime';

const usePollRemainingTime = () => {
  const { remainingTimeReadable, totalTimeReadable, remainingPercentage, isPollOpen } = usePublishedPollRemainingTime();
  return { remainingTimeReadable, totalTimeReadable, remainingPercentage, isPollOpen };
};

export default usePollRemainingTime;
